var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.3333C9.11603 13.3333 8.26818 12.9821 7.64306 12.357C7.01794 11.7319 6.66675 10.8841 6.66675 10C6.66675 9.11595 7.01794 8.2681 7.64306 7.64298C8.26818 7.01786 9.11603 6.66667 10.0001 6.66667C10.8841 6.66667 11.732 7.01786 12.3571 7.64298C12.9822 8.2681 13.3334 9.11595 13.3334 10C13.3334 10.8841 12.9822 11.7319 12.3571 12.357C11.732 12.9821 10.8841 13.3333 10.0001 13.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.3333C9.11603 13.3333 8.26818 12.9821 7.64306 12.357C7.01794 11.7319 6.66675 10.8841 6.66675 10C6.66675 9.11594 7.01794 8.2681 7.64306 7.64298C8.26818 7.01786 9.11603 6.66667 10.0001 6.66667M10.0001 13.3333C10.8841 13.3333 11.732 12.9821 12.3571 12.357C12.9822 11.7319 13.3334 10.8841 13.3334 10C13.3334 9.11594 12.9822 8.2681 12.3571 7.64298C11.732 7.01786 10.8841 6.66667 10.0001 6.66667M10.0001 13.3333V17.5M10.0001 6.66667V2.5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips);
export default __webpack_public_path__ + "static/media/trips.93b497a7e8ae227ab94e9b819981d7e5.svg";
export { ForwardRef as ReactComponent };